import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpInterceptor, HttpRequest, HttpEvent, HttpHandler } from '@angular/common/http';
import { AppConfigService } from '../services/config/app-config.service';

@Injectable()
export class ApiRouteInterceptorService implements HttpInterceptor {
  constructor(private _appConfigService: AppConfigService) {}
  private addUrlRoot(url: string) {
    if (url.startsWith('http') || url.startsWith('assets')) {
      return url;
    }
    return `${this._appConfigService.config.apiUrl}${url}`;
  }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const newReq = req.clone({ url: this.addUrlRoot(req.url) });
    return next.handle(newReq);
  }
}
